import '../scss/app.scss'

import { gsap } from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import {SplitText} from "gsap/SplitText";
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

gsap.registerPlugin(ScrollTrigger,ScrollToPlugin,SplitText);

import Lenis from 'lenis'
const lenis = new Lenis({
  autoRaf: true,
});

class ScrollBuilder {
    
    constructor() {
        const lenis = new Lenis({
            duration: 1.5
        });

        lenis.on('scroll', (e) => {  

            if (e.animatedScroll >= 96) {

                document.querySelector('.header').classList.add('sticky')

            } else {
                document.querySelector('.header').classList.remove('sticky')
            }

        })

        function raf(time) {
            lenis.raf(time)
            requestAnimationFrame(raf)
        }

        requestAnimationFrame(raf)

        return lenis;
    }
}
export const Scroll2 = new ScrollBuilder();


const swiper = new Swiper('.campi-slide', {
  spaceBetween: 10,
  loop: "true",
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  slidesPerView: 1.3,
  pagination: {
    el: ".swiper-pagination",
    dynamicBullets: true,
    clickable: true,
  },
  breakpoints: {
        640: {
          slidesPerView: 1.5,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 1.6,
          spaceBetween: 15,
        },
        1200: {
          slidesPerView: 1.6,
          spaceBetween: 20,
        },
        1400: {
          slidesPerView: 1.8,
          spaceBetween: 20,
        },
      },
});


const swiper2 = new Swiper('.four-slide', {
  spaceBetween: 10,
  loop: "true",
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  slidesPerView: 1,
  pagination: {
    el: ".swiper-pagination",
    dynamicBullets: true,
    clickable: true,
  },
  breakpoints: {
        640: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 15,
        },
        1200: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1400: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
      },
});


const swiper3 = new Swiper('.tecnici-slide', {
  spaceBetween: 10,
  loop: "true",
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  slidesPerView: 1.3,
  pagination: {
    el: ".swiper-pagination",
    dynamicBullets: true,
    clickable: true,
  },
  breakpoints: {
        640: {
          slidesPerView: 1.3,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 1.5,
          spaceBetween: 15,
        },
        1200: {
          slidesPerView: 2.2,
          spaceBetween: 20,
        },
        1400: {
          slidesPerView: 2.8,
          spaceBetween: 20,
        },
      },
});


const swiper4 = new Swiper('.gallery-slide', {
  spaceBetween: 10,
  loop: "true",
  freeMode: true,
  centered: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  slidesPerView: 1.3,
  pagination: {
    el: ".swiper-pagination",
    dynamicBullets: true,
    clickable: true,
  },
  breakpoints: {
        640: {
          slidesPerView: 1.3,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 2.5,
          spaceBetween: 15,
        },
        1200: {
          slidesPerView: 3.2,
          spaceBetween: 20,
        },
        1400: {
          slidesPerView: 3.8,
          spaceBetween: 20,
        },
      },
});

const swiper6 = new Swiper('.emblemi-slide', {
  spaceBetween: 5,
  loop: "true",
  freeMode: true,
  centered: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  slidesPerView: 2,
  pagination: {
    el: ".swiper-pagination",
    dynamicBullets: true,
    clickable: true,
  },
  breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 5,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 10,
        },
        1200: {
          slidesPerView: 5,
          spaceBetween: 10,
        },
        1400: {
          slidesPerView: 6,
          spaceBetween: 10,
        },
      },
});


const swiper5 = new Swiper('.links-slide', {
  loop: true,
  freeMode: true,
  centered: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  autoplay: {
    delay: 0,
    disableOnInteraction: false,
  },
  slidesPerView: 1.3,
  spaceBetween: 15,
  speed: 10000,
  pagination: {
    el: ".swiper-pagination",
    dynamicBullets: true,
    clickable: true,
  },
  breakpoints: {
        500: {
          slidesPerView: 1.3,
          spaceBetween: 15,
        },
        640: {
          slidesPerView: 2.3,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 3.5,
          spaceBetween: 25,
        },
        1200: {
          slidesPerView: 4.8,
          spaceBetween: 40,
        },
        1400: {
          slidesPerView: 5.8,
          spaceBetween: 50,
        },
      },
});

import Accordion from "accordion-js";
if (document.querySelectorAll('.accordion-container').length > 0) {
    new Accordion(".accordion-container");
}


const openButton = document.querySelector('.open-menu');
const closeButton = document.querySelector('.close-menu');
const menuOverlay = document.querySelector('.menu-overlay');
const menuItems = document.querySelectorAll('.menu li');

function toggleMenu() {
  menuOverlay.style.display = menuOverlay.style.display === 'none' ? 'flex' : 'none';
}

function closeMenu() {
  gsap.to(menuItems, {
    opacity: 0,
    x: -50,
    stagger: 0.1,
    onComplete: toggleMenu
  });
  gsap.to(menuOverlay, {
    left: '-100%',
    duration: 0.5
  });
}
   gsap.to(menuOverlay, {
    left: '-100%',
    duration: 0.5,
    opacity: 1,
  });

toggleMenu();
openButton.addEventListener('click', () => {
  console.log("ssssss");
  gsap.fromTo(menuOverlay, {
    left: '-100%',
    opacity: 1,
  }, {
    left: '0',
    duration: 0.5,
    opacity: 1,
  });
  
  gsap.fromTo(menuItems, {
    opacity: 0,
    x: -50
  }, {
    opacity: 1,
    x: 0,
    stagger: 0.1
  });
  toggleMenu();
});

closeButton.addEventListener('click', closeMenu);


setTimeout(()=>{

    if (document.querySelectorAll('.stagger-in').length > 0) {

        document.querySelectorAll('.stagger-in').forEach(el=>{


            let elements = el.querySelectorAll('.stagger-in__el')


            gsap.from(elements, {
                opacity: 0,
                duration: .8,
                yPercent:50,
                stagger: {
                    each: 0.1
                },
                scrollTrigger: {
                    trigger: el,
                    //markers: false,
                    start: "top 75%",
                }
            });

            gsap.to(elements, {
                opacity: 1,
                duration: .8,
                stagger: {
                    each: 0.1
                },
                scrollTrigger: {
                    trigger: el,
                    //markers: false,
                    start: "top 75%",
                }
            });

        });
    }
},250);
